import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import type { AvatarConfig } from '../../utils/avatar';

interface DiceBearAvatarProps {
  seed: string;
  config?: AvatarConfig;
  size?: number;
  sx?: SxProps<Theme>;
}

function buildAvatarUrl(seed: string, config?: AvatarConfig): string {
  const params = new URLSearchParams();
  params.set('seed', seed);

  if (config?.top?.[0]) params.set('top', config.top[0]);
  if (config?.eyes?.[0]) params.set('eyes', config.eyes[0]);
  if (config?.mouth?.[0]) params.set('mouth', config.mouth[0]);
  if (config?.clothing?.[0]) params.set('clothing', config.clothing[0]);
  if (config?.accessories?.[0]) params.set('accessories', config.accessories[0]);
  if (config?.hairColor?.[0]) params.set('hairColor', config.hairColor[0].replace('#', ''));
  if (config?.skinColor?.[0]) params.set('skinColor', config.skinColor[0].replace('#', ''));
  if (config?.clothesColor?.[0]) params.set('clothesColor', config.clothesColor[0].replace('#', ''));
  if (config?.backgroundColor?.[0]) params.set('backgroundColor', config.backgroundColor[0].replace('#', ''));
  if (config?.backgroundType?.[0]) params.set('backgroundType', config.backgroundType[0]);

  return `https://api.dicebear.com/9.x/avataaars/svg?${params.toString()}`;
}

const DiceBearAvatar: React.FC<DiceBearAvatarProps> = ({ seed, config, size = 32, sx }) => {
  const src = buildAvatarUrl(seed, config);

  return (
    <Box
      component="img"
      src={src}
      alt={seed}
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        objectFit: 'cover',
        flexShrink: 0,
        ...(sx as object),
      }}
    />
  );
};

export default DiceBearAvatar;
